import QRCode from 'qrcode';

export async function gerarQrBase64(payload) {
  const qrBase64 = await QRCode.toDataURL(payload);
  return qrBase64; // já vem em base64
}
